export enum PasswordStrength {
    STRENGTH_VERY_WEAK = 'very-weak',
    STRENGTH_WEAK = 'weak',
    STRENGTH_MEDIUM = 'medium',
    STRENGTH_STRONG = 'strong',
    STRENGTH_VERY_STRONG = 'very-strong',
}
